import { render, staticRenderFns } from "./HistoricoAditivos.vue?vue&type=template&id=3551eefa&"
import script from "./HistoricoAditivos.vue?vue&type=script&lang=js&"
export * from "./HistoricoAditivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports